import { useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import Icon from "@/icons";

export const MessageReport = ({ children, reportMessage }: { children: React.ReactNode, reportMessage: any }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [reason, setReason] = useState('');
    const [error, setError] = useState('');

    const reasons: { name: string, title: string, description: string, color: string }[] = [
        { name: "SPAM", title: "Spam", description: "This message contains spam", color: "red-500" },
        { name: "INAPPROPRIATE", title: "Inappropriate", description: "This message is inappropriate or offensive", color: "yellow-500" },
        { name: "HARASSMENT", title: "Harassment", description: "This message is harassing or bullying", color: "orange-500" },
        { name: "ABUSE", title: "Abuse", description: "This message contains abusive content", color: "purple-500" },
        { name: "HATE_SPEECH", title: "Hate Speech", description: "This message contains hate speech", color: "blue-500" },
        { name: "VIOLENCE", title: "Violence", description: "This message promotes violence", color: "red-700" },
        { name: "UNDERAGE", title: "Underage", description: "This message is from an underage user", color: "green-500" },
        { name: "OTHER", title: "Other", description: "This message has another issue", color: "gray-500" }
    ];

    const handleReport = async () => {
        if (!reason) {
            setError('Please select a reason');
            return;
        }

        const res = await fetch('__SITE_BASE__/api/v1/report/messages/' + reportMessage.id, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ reason }),
        });
        if (res.ok) {
            setIsOpen(false);
        } else {
            const data = await res.json();
            setError(data.message);
        }
    };

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger>
                {children}
            </DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 rounded-lg">
                <DialogHeader className="items-center justify-center">
                    <DialogTitle>
                        Report message
                    </DialogTitle>
                </DialogHeader>
                <div className="bg-red-500 text-white rounded-full w-8 h-8 flex items-center justify-center absolute -top-4 -right-4">
                    <Icon name="shield" size="16" />
                </div>
                <div className="flex flex-col gap-4 p-4">
                    <label className="text-sm font-semibold">Reason</label>
                    <div className="flex flex-col gap-2 bg-brand-profile p-2 rounded-lg">
                        {reasons.map((r, i) => (
                            <>
                            <div className={`hover:bg-brand-back/50 transition-all duration-300 rounded-lg p-2 cursor-pointer  ${reason === r.name ? 'bg-brand-back' : ''
                                }`} key={i} onClick={() => setReason(r.name === reason ? '' : r.name)}>
                                <div className="flex items-center gap-4">
                                    <div className={`text-${r.color} relative rounded-full p-1`}>
                                        <Icon name="shield" size="24" />
                                        <div className={`absolute -top-1 -right-1 -bottom-1 -left-1 border-2 border-dashed border-${r.color} rounded-full`}></div>
                                    </div>
                                    <div className="flex flex-col">
                                        <p className="text-white font-semibold">{r.title}</p>
                                        <p className="text-xs text-gray-300">{r.description}</p>
                                    </div>
                                </div>
                            </div>
                            {i !== reasons.length - 1 && <hr className="border-gray-700" />}
                            </>
                        ))}
                    </div>
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                    <button className="bg-brand-green px-5 py-2 w-full text-center rounded-lg text-white font-semibold hover:bg-green-500 disabled:opacity-50 transition-all duration-300"
                        disabled={!reason}
                        onClick={handleReport}>Report</button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
